import NavigationBar from "../../../components/navbar/NavigationBar";
import PageTitle from "../../../components/Page Title/PageTitle";
import React, { useState, useEffect } from "react";
import TankComponentImage from "./TankComponentImage";
import "./ComponentViewer.css";
import ge from "../../../assets/photos/ge.png";
import us from "../../../assets/photos/us.png";
import sov from "../../../assets/photos/sov.png";
import "../globals/global.css";
import { BiChevronRight, BiChevronLeft } from "react-icons/bi";

const compId = {
  0: "Engine",
  3: "Cannon Breach",
  4: "Ammo Compartment",
  5: "Turret Ring",
  6: "Fuel Tank",
  9: "Cannon Breach",
  10: "Internal Structure",
  11: "Transmission",
  24: "Left Wing",
  25: "Right Wing",
  26: "Elevator",
  27: "Rudder",
};
const groundVehicleTypes = [
  "Terrain Vehicles",
  "Armoured Personel Carriers",
  "Recon Vehicles",
];
const tankVehicleTypes = [
  "Light Tanks",
  "Medium Tanks",
  "Tank Destroyers",
  "Heavy Tank",
];
const planeVehicleTypes = ["Recon Planes", "Fighter Planes", "Heavy Fighters"];
const categorieslimits = {
  1: {
    "Light Tanks": [0, 2],
    "Medium Tanks": [3, 5],
    "Tank Destroyers": [6, 9],
    "Heavy Tank": [10, 11],
    "Recon Vehicles": [12, 13],
    "Recon Planes": [14, 14],
    "Fighter Planes": [15, 17],
    "Heavy Fighters": [18, 18],
    "Terrain Vehicles": [19, 22],
    "Armoured Personel Carriers": [23, 24],
  },
  2: {
    "Light Tanks": [0, 3],
    "Medium Tanks": [4, 6],
    "Tank Destroyers": [7, 9],
    "Heavy Tank": [10, 11],
    "Recon Vehicles": [12, 13],
    "Recon Planes": [14, 14],
    "Fighter Planes": [15, 17],
    "Heavy Fighters": [18, 18],
    "Terrain Vehicles": [19, 21],
    "Armoured Personel Carriers": [22, 23],
  },
  3: {
    "Light Tanks": [0, 3],
    "Medium Tanks": [4, 6],
    "Tank Destroyers": [7, 9],
    "Heavy Tank": [10, 11],
    "Recon Vehicles": [12, 14],
    "Recon Planes": [15, 15],
    "Fighter Planes": [16, 18],
    "Heavy Fighters": [19, 19],
    "Terrain Vehicles": [20, 23],
    "Armoured Personel Carriers": [24, 25],
  },
};

const vehicles = {
  1: [
    "M2A2 Light Tank",
    "M5A1 Stuart",
    "M24 Chaffee",
    "M3 Lee",
    "M4A1 Sherman",
    "M4A3E8 Sherman",
    "M10 Tank destroyer",
    "M18 Hellcat",
    "M36 Tank Destroyer",
    "M36B1 Tank Destroyer",
    "M4A3E2 Sherman 'Jumbo'",
    "M26 Pershing",
    "T8E1 Stuart Recce",
    "M8 Greyhound",
    "Curtiss O-52 Owl",
    "Seversky P-35A",
    "Curtiss P-40N Warhawk",
    "P-51D Mustang",
    "Lockheed P-38 Lightning",
    "Truck, 1/4 ton, 4x4",
    "M29 Weasel",
    "M16 MGMC",
    "QMC-4 1/4 Ton Amphibian",
    "CCKW Cargo Truck",
    "M3A1",
  ],
  2: [
    "Panzerkampfwagen I Ausf. A",
    "Panzerkampfwagen II Ausf. C",
    "Panzerkampfwagen 38(t) Ausf. E",
    "Panzerkampfwagen II Ausf. L",
    "Panzerkampfwagen III Ausf. J/1",
    "Panzerkampfwagen IV Ausf. H",
    "Panzerkampfwagen V Panther Ausf. G",
    "Jagdpanzer 38(t) Hetzer",
    "Sturmgeschütz III Ausf. F",
    "Panzerjäger V Jagdpanther",
    "Panzerkampfwagen VI Tiger Ausf. E",
    "Panzerkampfwagen VI Tiger II Ausf. B",
    "SdKfz 222",
    'SdKfz 234/2 "Puma"',
    "Henschel Hs 126 B-1",
    "Messerschmitt Bf 109D-1",
    "Messerschmitt Bf 109E-4",
    "Focke-Wulff Fw-190 D9",
    "Messerschmitt Me 410 B-2",
    "Kübelwagen Typ 82",
    "Type 166 Schwimmwagen",
    "SdKfz 7/1",
    "Blitz Truck",
    "sdKfz 251/1",
  ],
  3: [
    "T-38 Model 1934",
    "T-26 Model 1933",
    "BT-7 Model 1937",
    "T-70 Model 1942",
    "T-28 Model 1934",
    "T-34/76 Model 1942",
    "T-34/85 Model 1944",
    "SU-76M",
    "SU-85",
    "SU-100",
    "KV-85",
    "IS-2 Model 1944",
    "BA-64",
    "BA-6",
    "BA-11",
    "Polikarpov R-Z",
    "Mikoyan-Gurevich MiG-3",
    "Yakovlev Yak-9B",
    "Lavochkin La-7",
    "Petlyakov Pe-3bis",
    "GAZ-67",
    "T-20 Komsomolets",
    "QMC-4 1/4 Ton Amphibian",
    "GAZ-AAA M-4 Maxim",
    "GAZ-AAA Cargo",
    "M3A1",
  ],
};
const viewLabels = {
  0: "- Front/Back",
  1: "- Left/Right Side",
  2: "",
};
const images = [us, ge, sov];
const getImagePath = (factionId, vehicleIndex, componentId, view) =>
  `https://static.hng-group.com/WebsiteImages/ComponentViewer/${factionId}_${vehicleIndex}_${componentId}_${view}.jpg`;

const ComponentViewer = () => {
  const [selectedVehicleType, setSelectedVehicleType] = useState(() => {
    return localStorage.getItem("selectedVehicleType") || "Light Tanks";
  });

  const [selectedVehicleIdx, setSelectedVehicleIdx] = useState(() => {
    const stored = localStorage.getItem("selectedVehicleIdx");
    return stored ? parseInt(stored, 10) : 0;
  });

  const [selectedFactionId, setSelectedFactionId] = useState(() => {
    const stored = localStorage.getItem("selectedFactionId");
    return stored ? parseInt(stored, 10) : 2;
  });

  useEffect(() => {
    localStorage.setItem("selectedVehicleType", selectedVehicleType);
  }, [selectedVehicleType]);

  useEffect(() => {
    localStorage.setItem("selectedVehicleIdx", selectedVehicleIdx.toString());
  }, [selectedVehicleIdx]);

  useEffect(() => {
    localStorage.setItem("selectedFactionId", selectedFactionId.toString());
  }, [selectedFactionId]);
  const [validImages, setValidImages] = useState([]);

  const [modalData, setModalData] = useState(null);

  const handleSelectVehicle = (_, idx) => {
    const baseIdx = categorieslimits[selectedFactionId][selectedVehicleType][0];
    setSelectedVehicleIdx(baseIdx + idx);
  };

  useEffect(() => {
    const allImages = Object.entries(compId).flatMap(([compKey, compName]) =>
      [0, 1, 2].map((view) => {
        return {
          key: `tank-${compKey}-${view}`,
          path: getImagePath(
            selectedFactionId,
            selectedVehicleIdx,
            compKey,
            view
          ),
          label: compName,
          view,
          componentId: compKey,
        };
      })
    );

    const checkImages = async () => {
      const checks = await Promise.all(
        allImages.map(
          (img) =>
            new Promise((resolve) => {
              const image = new Image();
              image.src = img.path;
              image.onload = () => resolve(img);
              image.onerror = () => resolve(null);
            })
        )
      );
      setValidImages(checks.filter(Boolean));
    };

    checkImages();
  }, [selectedFactionId, selectedVehicleIdx]);

  const openModal = (index) => setModalData({ ...validImages[index], index });
  const closeModal = () => setModalData(null);
  const goPrev = () => {
    const newIndex =
      (modalData.index - 1 + validImages.length) % validImages.length;
    setModalData({ ...validImages[newIndex], index: newIndex });
  };
  const goNext = () => {
    const newIndex = (modalData.index + 1) % validImages.length;
    setModalData({ ...validImages[newIndex], index: newIndex });
  };

  return (
    <div className="pagebackground">
      <NavigationBar />
      <PageTitle title="Component Viewer" />
      <div className="pagebox pagebox-componentviewer">
        {/* Selecting faction row*/}
        <p className="sectionTitleText categoryTitle"> Select Faction</p>
        <div className="FactionRow">
          {images.map((_, idx) => (
            <div
              className="faction"
              onClick={() => setSelectedFactionId(idx + 1)}
            >
              <img
                src={images[idx]}
                className={
                  idx + 1 === selectedFactionId
                    ? "factioniconSelected"
                    : "factionicon"
                }
              />
              <div
                className={
                  idx + 1 === selectedFactionId
                    ? "underlineSelected"
                    : "underline"
                }
              ></div>
            </div>
          ))}
        </div>
        {/* Selecting vehicletype columns*/}
        <p className="sectionTitleText categoryTitle"> Select Vehicle Type</p>
        <div className="VehicleTypeColumns">
          <div className="vehicleTypeColumn">
            {groundVehicleTypes.map((val, idx) => (
              <div
                onClick={() => setSelectedVehicleType(val)}
                className={
                  val === selectedVehicleType
                    ? "vehicleTypeBox vehicleTypeBoxSelected"
                    : "vehicleTypeBox"
                }
              >
                {val}
              </div>
            ))}
          </div>

          <div className="vehicleTypeColumn">
            {tankVehicleTypes.map((val, idx) => (
              <div
                onClick={() => setSelectedVehicleType(val)}
                className={
                  val === selectedVehicleType
                    ? "vehicleTypeBox vehicleTypeBoxSelected"
                    : "vehicleTypeBox"
                }
              >
                {val}
              </div>
            ))}
          </div>

          <div className="vehicleTypeColumn">
            {planeVehicleTypes.map((val, idx) => (
              <div
                onClick={() => setSelectedVehicleType(val)}
                className={
                  val === selectedVehicleType
                    ? "vehicleTypeBox vehicleTypeBoxSelected"
                    : "vehicleTypeBox"
                }
              >
                {val}
              </div>
            ))}
          </div>
        </div>

        {/* Selecting vehicle row*/}
        <p className="sectionTitleText categoryTitle"> Select Vehicle </p>
        <div className="vehicleIconRow">
          {(selectedVehicleType === "Select an option" ||
          selectedFactionId === -1
            ? []
            : vehicles[selectedFactionId.toString()].slice(
                categorieslimits[selectedFactionId.toString()][
                  selectedVehicleType
                ][0],
                categorieslimits[selectedFactionId.toString()][
                  selectedVehicleType
                ][1] + 1
              )
          ).map((val, idx) => (
            <div>
              <img
                onClick={() => handleSelectVehicle(val, idx)}
                className={
                  categorieslimits[selectedFactionId][selectedVehicleType][0] +
                    idx ===
                  selectedVehicleIdx
                    ? "vehicleIconSelected"
                    : "vehicleIcon"
                }
                src={
                  "tankthumbnails/" +
                  selectedFactionId +
                  "_" +
                  (categorieslimits[selectedFactionId][selectedVehicleType][0] +
                    idx) +
                  ".png"
                }
                alt={val}
              />
              <div
                className={
                  categorieslimits[selectedFactionId][selectedVehicleType][0] +
                    idx ===
                  selectedVehicleIdx
                    ? "underlineSelected"
                    : "underline"
                }
              ></div>
            </div>
          ))}
        </div>

        {
          <div className="componentgrid">
            {validImages.map((imgData, index) => (
              <TankComponentImage
                key={imgData.key}
                path={imgData.path}
                label={imgData.label}
                view={imgData.view}
                onClick={() => openModal(index)}
              />
            ))}
          </div>
        }

        {modalData && (
          <div className="modal" onClick={closeModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <BiChevronLeft className="NextPrevIcon" onClick={goPrev} />
              <div className="modalImageColumn">
                <p className="sectionSubTitleText categoryTitle">
                  {modalData.label + " " + viewLabels[modalData.view]}
                </p>
                <img
                  className="modal-image"
                  src={modalData.path}
                  alt={modalData.label}
                />
              </div>
              <BiChevronRight onClick={goNext} className="NextPrevIcon" />
            </div>
          </div>
        )}

        <p className="sectionTitleText">Tank Combat in Heroes and Generals</p>
        <p className="sectionBodyText">
          For a good understanding of how armour 2.0 damage system works, here
          is a great youtube video that i found that explains it clearly
        </p>
        <div className="armourdamagemodelvideo">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/gFqSaPhsKbY?start=557"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default ComponentViewer;
